import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Spin, Switch, Tooltip, Icon } from 'antd';
import AdaptChart from './AdaptChart';
import API_URL from '../../../../common/url';
import Fetch from '../../../../common/Fetch';
import ExportUtil from '../../../../common/ExportUtil';
import { DefaultParams } from '../../constants/project';

class ChartBox extends PureComponent {
    static contextTypes = {
        handleExpand: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            loading: false,
            showLegend: false
        };
    }

    componentDidMount() {
        if (this.props.params.statisticDate) {
            this.loadData();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.refresh !== this.props.refresh) {
            this.loadData();
        }
    }

    loadData = () => {
        const { activeKey } = this.context;
        const { moduleType, params } = this.props;
        const { investigationMedicineType = [] } = params;
        this.setState({ loading: true });
        const settings = {
            year: params.statisticDate,
            statisticDate: `${params.statisticDate}-01`,
            statisticEndDate: `${params.statisticDate}-12`,
            investigationMedicineType: investigationMedicineType[0],
            secondResearchProductType: investigationMedicineType[1],
            //...DefaultParams[activeKey]
        };
        Fetch.post(API_URL.dashboard.queryStatisticReportData, {
            moduleType,
            ...params,
            ...settings,
        }).then(res => {
            this.setState({
                data: res,
                loading: false
            });
        });
    }

    handleExport = () => {
        const { moduleType, params } = this.props;
        const settings = {
            year: params.statisticDate,
            statisticDate: `${params.statisticDate}-01`,
            statisticEndDate: `${params.statisticDate}-12`,
        };
        ExportUtil.export({
            moduleType,
            ...params,
            ...settings,
        }, null, API_URL.dashboard.exportStatisticReportData)
    }

    handleChange = (checked) => {
        this.setState({ showLegend: checked });
    }

    render() {
        const { handleExpand } = this.context;
        const { title, tips, chartTypes, toType,dataType,params } = this.props;
        const { loading, showLegend, data } = this.state;
        return (
            <div className="flexItem outer">
                <Spin spinning={loading}>
                    <div className="chartHeader">
                        <div className="modTitle">
                            <span>{title}</span>
                            {
                                tips &&
                                <Tooltip overlayStyle={{ width: 210, wordBreak: 'break-all' }} placement="top" title={tips}>
                                    <Icon style={{ marginLeft: 6, fontSize: '14px', cursor: 'pointer' }} type="info-circle-o" />
                                </Tooltip>
                            }
                            <div className="legendContainer" style={{ display: 'inline-block', fontWeight: 'normal', color: '#999',marginLeft:"5px" }}>
                                <Switch size="small" checked={showLegend} onChange={this.handleChange} 
                                 style={{marginBottom:"2px"}}/>
                                <span className="text">{!showLegend?"图例隐藏":"图例显示"}</span>
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: 20 }}>
                        <AdaptChart
                            data={data}
                            filename={title}
                            dataType={dataType}
                            showLegend={showLegend}
                            chartTypes={chartTypes}
                            onExport={this.handleExport}
                        />
                    </div>
                </Spin>
                <div className="footer">
                { toType &&<a className="more" onClick={() => handleExpand(toType,params)}>MORE</a>}
                </div>
            </div>
        );
    }
}

export default ChartBox;


// WEBPACK FOOTER //
// ./src/components/homePage/projectIndicatorAnalysis/components/ChartBox.js